import { combineReducers } from 'redux'
import { combineForms } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminInviteActions'

const initialInviteModel = {
  users: ''
}

export default combineReducers({
  inviteRequest: h2Api.restReducer(actions.SEND_INVITES),
  getCodeRequest: h2Api.restReducer(actions.GET_CODE),
  changeCodeRequest: h2Api.restReducer(actions.CHANGE_CODE),
  forms: combineForms({ inviteForm: initialInviteModel }, 'admin.users.invite.forms')
})
